export enum UserRole {
    SUPERADMIN = 1,
    MANAGER = 2,
    AFFILIATE = 3
}